export type LeadStatus =
  | 'new'
  | 'contacted'
  | 'demo_scheduled'
  | 'proposal_sent'
  | 'nurture'
  | 'won'
  | 'lost';

export interface CompanyLead {
  id: string;
  name: string;
  email: string;
  organization_name: string | null;
  role: string | null;
  phone: string | null;
  league_size: string | null;
  intent: string | null;
  timeline: string | null;
  message: string;
  source_path: string | null;
  referrer: string | null;
  status: LeadStatus;
  internal_notes: string | null;
  follow_up_at: string | null;
  created_at: string;
  updated_at: string | null;
  read: number;
}

export const LEAD_STATUSES: Array<{ value: LeadStatus; label: string; tone: 'info' | 'warn' | 'ok' | 'err' | 'accent' }> = [
  { value: 'new', label: 'New', tone: 'info' },
  { value: 'contacted', label: 'Contacted', tone: 'accent' },
  { value: 'demo_scheduled', label: 'Demo scheduled', tone: 'warn' },
  { value: 'proposal_sent', label: 'Proposal sent', tone: 'warn' },
  { value: 'nurture', label: 'Nurture', tone: 'info' },
  { value: 'won', label: 'Won', tone: 'ok' },
  { value: 'lost', label: 'Lost', tone: 'err' },
];

const STATUS_MAP = new Map(LEAD_STATUSES.map((status) => [status.value, status]));

export function leadStatusMeta(status: string | null | undefined) {
  return STATUS_MAP.get(status as LeadStatus) ?? STATUS_MAP.get('new')!;
}

export function formatDate(value: string | null | undefined) {
  if (!value) return 'Not set';
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const date = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function intentLabel(value: string | null | undefined) {
  switch (value) {
    case 'book_demo':
      return 'Book a demo';
    case 'bring_to_league':
      return 'Bring to my league';
    case 'general_question':
      return 'General question';
    case 'partnership':
      return 'Partnership';
    case 'product_feedback':
      return 'Product feedback';
    default:
      return 'Not specified';
  }
}

export function timelineLabel(value: string | null | undefined) {
  switch (value) {
    case 'soon':
      return 'As soon as possible';
    case 'this_season':
      return 'This season';
    case 'next_season':
      return 'Next season';
    case 'exploring':
      return 'Just exploring';
    default:
      return 'Not specified';
  }
}
